import { OrderCreatorInterface } from "@/interface/order.inteface";

export default class OrderCreator implements OrderCreatorInterface {
  readonly id: string = "";
  readonly name: string = "";
  readonly email: string = "";

  constructor(data) {
    if (data) {
      this.id = data.id || "";
      this.email = data.email || "";
      this.name = this.getFullName(data);
    }
  }

  /**
   * Get Creator Full Name
   * @param data
   */
  public getFullName(data: any): string {
    return `${data.first_name} ${data.last_name}`;
  }
}
